import { useEffect } from 'react';
import { featureDetectionActions } from 'actions';
import useRedux from './useRedux';

/**
 * A hook to dispatch an action to queue browser features to check
 * FeatureDetectionContainer will pick them up, and show a modal
 * if some required features are missing
 *
 * This hook is meant to run once, on page load.
 * Adding featuresToCheck to the dependency array
 * will result in infinite calling of the hook.
 *
 * @param {Array} featuresToCheck
 */
const useFeatureDetection = (featuresToCheck) => {
  const featureDetectionReducerAndActions = useRedux('featureDetectionReducer', featureDetectionActions);
  const { checkFeatures } = featureDetectionReducerAndActions;

  useEffect(() => {
    checkFeatures(featuresToCheck);
  }, [checkFeatures]);

  return featureDetectionReducerAndActions;
};

export default useFeatureDetection;
